import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useEffect } from 'react';

const ChatBot = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (!isMobile) {
      const script = document.createElement('script');
      script.src = process.env.REACT_APP_CHAT_BOT_URL || '';
      script.setAttribute('data-id', process.env.REACT_APP_CHAT_BOT_ID || '');
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [isMobile]);

  return null;
};

export default ChatBot;
